























import {
  defineComponent,
  ref
} from '@vue/composition-api'

import { TcRadioButton } from '@telia/shared-ui-components'

export default defineComponent({
  components: {
    TcRadioButton
  },
  props: {
    serviceProviders: {
      type: Array,
      required: true
    },
    value: {
      type: String,
      default: 'Telia'
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  setup ({ value }, context) {
    const internalValue = ref(value)
    const handleSelection = (provider: string) => context.emit('change', provider)

    return {
      handleSelection,
      internalValue
    }
  }
})
